import configuration from "../configuration/keys";
import {
  E_ADMIN_ROLE,
  E_KHATTABAT_CONVERSATION_TYPE,
  TAdmin,
  TAdminRole,
  TAdminVersionStates,
  TalkhattabatConversationType,
  TKhattabatHeaderMenuItem,
  TKhattabatProfileInfoRow,
  TKhattabatSubscriptionChip
} from "../Types";
import { TKhattabatOneOTwoMessageMetadata } from "../types/khattabat-one-o-two-message.type";

export const ADMIN_VERSION_DEFAULT_STATES: TAdminVersionStates = {
  isActive: true,
  isUnderMaintenance: false,
  latestAdminVersion: configuration.version
};

export const SESSION_HOURS_TIME_LIMIT = 8;
export const ONE_DAY_TOTAL_HOURS = 24;

export const MAX_KHATTABA_ASSIGNEES = 100;

export const ONE_O_ONE_CONVERSATION_TYPES: TalkhattabatConversationType[] = [
  E_KHATTABAT_CONVERSATION_TYPE.ONE_O_ONE_C,
  E_KHATTABAT_CONVERSATION_TYPE.ONE_O_ONE_C_COMMENTS
];

export const KHATTABAT_TRIAL_SUBSCRIPTION_CHIP: TKhattabatSubscriptionChip = {
  labelKey: "TRIAL",
  color: "default"
};

export const USER_ADVANCED_PAGE_LINK = "/users/advanced";
export const USER_MESSAGES_PAGE_LINK = "/users/messages";
export const USER_PAYMENTS_PAGE_LINK = "/users/payments";
export const USER_EVENTS_PAGE_LINK = "/users/events";
export const CHANGE_PASSWORD_PAGE_LINK = "/CSR/changePassword";
export const LOGIN_PAGE_LINK = "/";

export const KHATTABAT_AUTH_CARD_MAX_WIDTH = 400;
export const KHATTABAT_LOGIN_LOGO_WIDTH = 96;

export const KHATTABAT_HEADER_MENU_ITEMS = ({
  isKhattabaAiAdmin,
  totalUnassignedNewClients,
  totalMaleUnreadMessages,
  totalFemaleUnreadMessages
}: {
  isKhattabaAiAdmin: boolean;
  totalUnassignedNewClients: number;
  totalMaleUnreadMessages: number;
  totalFemaleUnreadMessages: number;
}): TKhattabatHeaderMenuItem[] => [
  {
    link: "/khattabat/newClients",
    page: "KHATTABAT_NEW_CLIENTS",
    textKey: "NEW_CLIENTS",
    counter: totalUnassignedNewClients,
    isCounterVisible: true,
    isVisible: !isKhattabaAiAdmin
  },
  {
    link: "/khattabat/Male",
    page: "KHATTABAT_M",
    textKey: "MALE_CLIENTS",
    counter: totalMaleUnreadMessages,
    isCounterVisible: !isKhattabaAiAdmin,
    isVisible: true
  },
  {
    link: "/khattabat/Female",
    page: "KHATTABAT_F",
    textKey: "FEMALE_CLIENTS",
    counter: totalFemaleUnreadMessages,
    isCounterVisible: !isKhattabaAiAdmin,
    isVisible: true
  },
  {
    link: "/khattabatMatching/results",
    page: "KHATTABAT_MATCHING_RESULTS",
    textKey: "KHATTABAT_MATCHING_RESULTS",
    counter: 0,
    isCounterVisible: false,
    isVisible: !isKhattabaAiAdmin
  }
];

export const PROFILE_DROPDOWN_INFO_ROWS = (
  lastLogin: string
): TKhattabatProfileInfoRow[] => [
  { titleKey: "LAST_LOGIN", value: lastLogin },
  { titleKey: "DEPLOYED", value: configuration.date },
  { titleKey: "ENVIRONMENT", value: configuration.env },
  { titleKey: "VERSION", value: configuration.version }
];

export const MIN_KHATTABA_ASSIGNEES = 1;

export const KHATTABAT_ONE_O_TWO_MIN_QUALITY_MESSAGES = 50;

export const KHATTABAT_ONE_O_TWO_DEFAULT_MESSAGE_METADATA: TKhattabatOneOTwoMessageMetadata =
  {
    reactionId: 0,
    reactions: [],
    reactionHistory: [],
    isHidden: 0,
    hiddenActions: [],
    hideHistory: []
  };

export const KHATTABAT_REACTIVATION_DELAY_DAYS = 30;

export const ONE_MONTH_RANGE = 32;

export const DEFAULT_KHATTABAT_AI_FLTER_STATUS_VALUE = {
  label: "All",
  value: "all"
};

export const DEFAULT_KHATTABAT_USER_LOGOUT: TAdmin = {
  id: -1,
  username: "",
  fullName: "",
  role: "",
  lastLogin: "",
  needResetPassword: false
};

export const KHATTABA_POSSIBLE_ROLES: TAdminRole[] = [
  E_ADMIN_ROLE.KHATTABA_ADMIN,
  E_ADMIN_ROLE.KHATTABA_ADMIN_AI,
  E_ADMIN_ROLE.KHATTABA_ADMIN_TESTER
];
